import React from 'react';
import { Link } from 'react-router-dom';
import { l10n } from '../../i18n/Localization';

const CharacterCard = (props) => {
    const { character } = props;
    const characterURL = `/characters/${character.id}`;
    const editCharacterURL = `/characters/${character.id}/edit`;

    return (
        <div className="card bg-dark text-white border-light h-100">
            <div className="card-body">
                <h5 className="card-title">{character.identificationName}</h5>
                <p className="card-text">{character.gameCode.wireName}</p>
            </div>
            <div className="card-footer">
                <div className="d-flex justify-content-end">
                    <Link className="btn btn-primary mr-3" to={editCharacterURL}><i className="bi-pencil-fill mr-2"></i>{l10n.action.edit}</Link>
                    <Link className="btn btn-primary" to={characterURL}><i className="bi-zoom-in mr-2"></i>{l10n.action.view}</Link>
                </div>
            </div>
        </div>
    );
};

export default CharacterCard;
